<template>
	<v-card class="rounded-card" raised :key="randomizer">
		<v-dialog width="75%" v-model="preview" @keydown.esc="$router.push('/')">
			<MeetingCard :speaker="speaker" :enticement="enticement" :title="title"
				:image="website + '/meeting/' + meetingDate.substring(0, 7) + '/speaker_01.jpg'" :meetingDate="meetingDate"
				:meetingID="meeting_id" :meeting_url="meeting_url" :membershareTitle="membershare_title"
				:membershareDescription="membershare_description"
				:virtual_location="$store.state.meetingInfo.virtual_location"
				>
			</MeetingCard>
		</v-dialog>
		<v-sheet class="gradient">
			<v-container fill-height fluid>
				<v-layout row-wrap>
					<v-flex xs12 align-end flexbox>
						<div class="text-h6 font-weight-black white--text">
							<v-btn v-if="editing" small fab rounded color="primary" v-on:click.stop
								@click.exact="showDatePicker = !showDatePicker">
								<v-icon medium dark>event</v-icon>
							</v-btn>
							{{ meetingDate | formatDateMonthYear }}
							<span class="font-weight-light">Monthly Meeting</span>
						</div>
						<div v-if="!editing" class="text-h6 font-weight-black white--text"><span
								class="font-weight-light">Featured Speaker:</span> {{ speaker }}</div>
						<v-scale-transition>
							<v-date-picker @input="showDatePicker = false" v-if="editing && showDatePicker"
								v-model="meetingDate" :landscape="true" />
						</v-scale-transition>
						<v-text-field v-if="editing" v-model="speaker" label="Featured Speaker"
							class="headline font-weight-black" dark />
					</v-flex>
					<v-flex v-if="editing" xs9>
						<TimePicker label="Start Time" v-model="time" class="headline font-weight-black" dark />
						<v-text-field label="Meeting address or Zoom URL" v-model="meeting_url" dark />
					</v-flex>
					<v-flex xs1 class="text-right">
						<div v-if="true" comment="don't show until Landing page editor works">
							<v-icon v-if="showEditIcon && $store.state.roles.includes('meetings')" right dark
								v-on:click.stop @click.exact="editing = true">edit</v-icon>
						</div>
						<v-icon right dark v-on:click.stop @click.exact="cancel()">close</v-icon>
					</v-flex>
				</v-layout>
			</v-container>
		</v-sheet>
		<v-img v-if="false" @mouseover="showEditIcon = true" @mouseout="showEditIcon = false"
			:src="website + '/res/bg-018.jpg'" aspect-ratio="16">
			<v-container fill-height fluid>
				<v-layout fill-height>
					<v-flex xs12 align-end flexbox>
						<div class="text-h6 font-weight-black white--text">
							<v-btn v-if="editing" small fab rounded color="primary" v-on:click.stop
								@click.exact="showDatePicker = !showDatePicker">
								<v-icon medium dark>event</v-icon>
							</v-btn>
							{{ meetingDate | formatDateMonthYear }}
							<span class="font-weight-light">Monthly Meeting</span>
						</div>
						<div v-if="!editing" class="text-h6 font-weight-black white--text"><span
								class="font-weight-light">Featured Speaker:</span> {{ speaker }}</div>
						<v-scale-transition>
							<v-date-picker @input="showDatePicker = false" v-if="editing && showDatePicker"
								v-model="meetingDate" :landscape="true" />
						</v-scale-transition>
						<v-text-field v-if="editing" v-model="speaker" label="Featured Speaker"
							class="headline font-weight-black" dark />
					</v-flex>
					<v-flex xs1 class="text-right">
						<div v-if="false" comment="don't show until Landing page editor works">
							<v-icon v-if="showEditIcon && $store.state.roles.includes('meetings')" right dark
								v-on:click.stop @click.exact="editing = true">edit</v-icon>
						</div>
						<v-icon right dark v-on:click.stop @click.exact="cancel()">close</v-icon>
					</v-flex>
				</v-layout>
			</v-container>
		</v-img>
		<v-layout row wrap v-if="editing">
			<v-card xs12 color="grey lighten-2">
				<v-card-title>
					<div class="title font-weight-black">File upload zone:</div>
					<v-flex ma-1 v-for="i in 3" :key="i">
						<DropUpload width="140" height="140" uploadWhere="speaker" @uploadComplete='refreshImages'
							:transparent=true :clickable=true :newsletter="'speaker_0' + i + '.jpg'" :date="imageURL">
							<v-img width="140" height="140" class="floatleft elevation-10"
								:src="website + '/meeting/' + imageURL + '/speaker_0' + i + '.jpg?rnd=' + randomizer">
								<div v-if="editing">Drop photo #{{ i }} here</div>
							</v-img>
						</DropUpload>
					</v-flex>
					<v-flex ma-1>
						<DropUpload width="140" height="140" uploadWhere="newsletter" @uploadComplete='refreshImages'
							:transparent=true :clickable=true :newsletter="'lenspaper_' + newspaperURL + '.pdf'"
							:date="newspaperURL" acceptedFiles="application/pdf" :maxFileSize=20.0>
							<v-card class="elevation-10" max-width="140px" height="140px">
								<div class="dropzone-custom-content">
									<v-icon large>cloud_upload</v-icon>
								</div>
								<span class="text-break" v-if="newsletterWasUploaded">To update the newsletter, </span><span
									class="text-break" v-if="editing">Drop <span v-if="newsletterWasUploaded">a new </span>
									PDF here</span>
							</v-card>
						</DropUpload>
						<div v-if="newsletterWasUploaded">
							<a
								:href="website + '/newsletter/' + newspaperURL + '/lenspaper_' + newspaperURL + '.pdf?rnd=' + randomizer">Newsletter
								was uploaded. To see it, click here to download</a>
						</div>
					</v-flex>
				</v-card-title>
				<DropUpload width="140" height="140" uploadWhere="speaker" @uploadComplete='refreshImages' :transparent=true
					:clickable=true :newsletter="'speaker_04.jpg'" :date="imageURL">
					<v-img width="140" height="140" class="floatleft elevation-10"
						:src="website + '/meeting/' + imageURL + '/speaker_04.jpg?rnd=' + randomizer">
						<div v-if="editing">Drop photo #{{ 4 }} here</div>
					</v-img>
				</DropUpload>
			</v-card>
		</v-layout>
		<v-card-title>
			<div v-if="!editing">
				<img class="floatleft elevation-10"
					:src="website + '/meeting/' + imageURL + '/speaker_01.jpg?rnd=' + randomizer">
				<div class="text-h6 text-break">{{ title }}</div>
				<p class="body-1">Program Description</p>
				<img class="floatright elevation-10"
					:src="website + '/meeting/' + imageURL + '/speaker_02.jpg?rnd=' + randomizer" />
				<div class="body-2 text-break" v-if="!editing" v-html="formattedTopic()"></div>
				<br />
				<img class="elevation-10" :src="website + '/meeting/' + imageURL + '/speaker_03.jpg?rnd=' + randomizer" />
			</div>
		</v-card-title>
		<v-card-text v-if="editing" ma-0 pa-0>
			<v-layout wrap>
				<v-flex sm6 xs12 pa-1>
					<v-text-field autofocus v-model="title" label="Title" />
				</v-flex>
				<v-flex sm6 xs12 pa-1>
					<v-textarea hide-details full-width outlined v-model="topic" placeholder="Meeting Topic" />
				</v-flex>
				<v-flex sm6 xs12 pa-1>
					<v-textarea hide-details auto-grow full-width outlined v-model="enticement" placeholder="Enticement" />
				</v-flex>
				<v-flex sm6 xs12 pa-1>
					<v-text-field hide-details v-model="membershare_title" label="Member Share Title" />
				</v-flex>
				<v-flex sm6 xs12 pa-1>
					<Editor api-key="2ok38ee479iqsfzkkik6rr7zgctyr025npz221pbsei5hy4t" hide-details
						:init="{ 'browser_spellcheck': true, 'menubar': false, 'plugins': ['link', 'lists', 'code', 'preview'], 'toolbar': 'undo redo | formatselect | bold italic | link | alignleft aligncenter alignright alignjustify bullist code' }"
						v-model="membershare_description" />
				</v-flex>
				<v-flex sm6 xs12 pa-1>
					<v-textarea hide-details auto-grow full-width outlined v-model="notes" placeholder="Program Notes" />
				</v-flex>
			</v-layout>
		</v-card-text>
		<v-card-actions v-if="editing">
			<v-btn rounded outlined small @click="preview = true">Preview</v-btn>
			<v-spacer />
			<v-btn rounded outlined small @click="cancel()">Cancel</v-btn>
			<v-btn rounded small color="primary" @click="saveMeeting()">Save</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import { format, parseISO } from 'date-fns'
import DropUpload from '@/components/DropUpload'
import MeetingCard from '@/components/MeetingCard'
import TimePicker from '@/components/TimePicker'
import Editor from '@tinymce/tinymce-vue'
import { TokenService } from '@/services/storage.service'
import axios from 'axios'

export default {
	components: {
		DropUpload,
		Editor,
		MeetingCard,
		TimePicker
	},
	props: {
		speaker: { type: String, default: '' },
		enticement: { type: String, default: '' },
		title: { type: String, default: '' },
		topic: { type: String, default: '' },
		meetingDate: { type: String, default: '' },
		membershare_title: { type: String, default: '' },
		meeting_url: { type: String, default: '' },
		membershare_description: { type: String, default: '' },
		notes: { type: String, default: '' },
		meeting_id: Number,
		editing: Boolean,
		newsletterWasUploaded: { type: Boolean, default: true }
	},
	data: function () {
		return {
			randomizer: 0,
			topicWithCRs: '',
			showEditIcon: false,
			showDatePicker: false,
			preview: false,
			time: "18:00"
		}
	},
	watch: {
		'topic'() {
			this.topicWithCRs = this.formattedTopic()
		},
		'meetingDate'() {
			this.time = this.meetingDate.substr(11, 5)
		}
	},
	mounted() {
		this.refreshImages()
		this.time = this.meetingDate.substr(11, 5)
	},
	computed: {
		website: function () {
			return process.env.VUE_APP_WEBSITE
		},
		imageURL: function () {
			if (this.meetingDate <= '2013') {
				return format(parseISO(this.meetingDate), 'yyyy_MM', new Date())
			} else {
				return format(parseISO(this.meetingDate), 'yyyy-MM', new Date())
			}
		},
		newspaperURL: function () {
			return format(parseISO(this.meetingDate), 'yyyy_MM', new Date())
		}
	},
	methods: {
		refreshImages() {
			this.randomizer = Math.random()
		},
		cancel() {
			this.$emit('close-dialog')
		},
		formattedTopic() {
			if (this.topic !== undefined) {
				return this.topic.replace(/\n/g, '<br/>').replace(/\r/g, '<br/>')
			}
		},
		saveMeeting() {
			var bodyFormData = new FormData()
			bodyFormData.append('Username', TokenService.getUsername())
			bodyFormData.append('token', TokenService.getToken())
			bodyFormData.append('meetingdate', this.meetingDate.substr(0, 11) + ' ' + this.time + ':00')
			bodyFormData.append('membershare_description', this.membershare_description)
			bodyFormData.append('notes', this.notes)
			bodyFormData.append('membershare_title', this.membershare_title)
			bodyFormData.append('id', this.meeting_id)
			bodyFormData.append('title', this.title)
			bodyFormData.append('enticement', this.enticement)
			bodyFormData.append('topic', this.topic)
			bodyFormData.append('speaker', this.speaker)
			bodyFormData.append('location', this.meeting_url)
			axios.post(process.env.VUE_APP_WEBSITE + '/memberlogin2/api_savemeeting.php', bodyFormData).then((response) => {
				if (response.data.error === 'Wrong username or password') {
					alert('You are not logged in, or do not have permission to do this')
				} else {
					this.cancel()
				}
			}, function (error) {
				alert('Save comments:' + error)
			})
		}
	}
}
</script>

<style scoped>
img.floatleft {
	margin: 5px 7px 7px 5px;
	float: left;
}

img.floatright {
	margin: 5px 5px 7px 7px;
	float: right;
}

.gradient {
	background: linear-gradient(180deg, #555555 0%, #555555 100%);
}
</style>
